let project = 'vitDev' // Default Project
console.log('firebase-config.js', process.env)

const configs = {
  siosUs: {
    'apiKey': 'AIzaSyC0s6ZrviWrbZOnWysYYIIGb2MfyElGKxg',
    'databaseURL': 'https://mia-1on1navi-sios-us.firebaseio.com',
    'storageBucket': 'mia-1on1navi-sios-us.appspot.com',
    'authDomain': 'mia-1on1navi-sios-us.firebaseapp.com',
    'messagingSenderId': '464444660305',
    'projectId': 'mia-1on1navi-sios-us'
  },
  netone: {
    'apiKey': 'AIzaSyB8Hj4xjwASaDj79NgJxAHV3RUM8gWucoM',
    'databaseURL': 'https://mia-1on1navi-netone.firebaseio.com',
    'storageBucket': 'mia-1on1navi-netone.appspot.com',
    'authDomain': 'mia-1on1navi-netone.firebaseapp.com',
    'messagingSenderId': '27699473060',
    'projectId': 'mia-1on1navi-netone'
  },
  technopian: {
    'apiKey': 'AIzaSyC3pKv6ikNeBNKs2Zuciu1ksrgnUdRGT8Q',
    'databaseURL': 'https://mia-1on1navi-technopian.firebaseio.com',
    'storageBucket': 'mia-1on1navi-technopian.appspot.com',
    'authDomain': 'mia-1on1navi-technopian.firebaseapp.com',
    'messagingSenderId': '247002965276',
    'projectId': 'mia-1on1navi-technopian'
  },
  grandP: {
    'apiKey': 'AIzaSyBddwXFb3pPKh2XZ-kcj5fAKrmaqBMWlyI',
    'databaseURL': 'https://mia-1on1navi-grand-p.firebaseio.com',
    'storageBucket': 'mia-1on1navi-grand-p.appspot.com',
    'authDomain': 'mia-1on1navi-grand-p.firebaseapp.com',
    'messagingSenderId': '581440668747',
    'projectId': 'mia-1on1navi-grand-p'
  },
  unimedia: {
    'projectId': 'mia-1on1navi-unimedia',
    'databaseURL': 'https://mia-1on1navi-unimedia.firebaseio.com',
    'storageBucket': 'mia-1on1navi-unimedia.appspot.com',
    'apiKey': 'AIzaSyDlmmMCDhu5FaR2_JxSWt43Xe8cVKzGZyQ',
    'authDomain': 'mia-1on1navi-unimedia.firebaseapp.com',
    'messagingSenderId': '552786603649'
  },
  kps: {
    'apiKey': 'AIzaSyClQEiLF_2twVtUYiSjEfsd9CFY_0TKWn0',
    'databaseURL': 'https://mia-1on1navi-kps.firebaseio.com',
    'storageBucket': 'mia-1on1navi-kps.appspot.com',
    'authDomain': 'mia-1on1navi-kps.firebaseapp.com',
    'messagingSenderId': '861843832954',
    'projectId': 'mia-1on1navi-kps'
  },
  sios: {
    'apiKey': 'AIzaSyBNjS21aP8AVlFLUDSYqoFzBNsG6IUz-Fk',
    'databaseURL': 'https://mia-1on1navi-sios.firebaseio.com',
    'storageBucket': 'mia-1on1navi-sios.appspot.com',
    'authDomain': 'mia-1on1navi-sios.firebaseapp.com',
    'messagingSenderId': '602022826912',
    'projectId': 'mia-1on1navi-sios'
  },
  ccbji: {
    'apiKey': 'AIzaSyBnnzFPMuD45c0D1cDbh8K1xRUWcL5PUrQ',
    'databaseURL': 'https://mia-1on1navi-ccbji.firebaseio.com',
    'storageBucket': 'mia-1on1navi-ccbji.appspot.com',
    'authDomain': 'mia-1on1navi-ccbji.firebaseapp.com',
    'messagingSenderId': '153735606042',
    'projectId': 'mia-1on1navi-ccbji'
  },
  dentsudigitalTrial: {
    'apiKey': 'AIzaSyA9fSZdjf7q4s1zRJ0VduH9q_R_40MRqoY',
    'databaseURL': 'https://mia-1on1navi-dentsudigital-tri.firebaseio.com',
    'storageBucket': 'mia-1on1navi-dentsudigital-tri.appspot.com',
    'authDomain': 'mia-1on1navi-dentsudigital-tri.firebaseapp.com',
    'messagingSenderId': '276931187206',
    'projectId': 'mia-1on1navi-dentsudigital-tri'
  },
  sasReferral: {
    'apiKey': 'AIzaSyAKfNATyQcBhZFbuFclsT5REC9Qnsus3wc',
    'databaseURL': 'https://mia-1on1navi-sas-referral.firebaseio.com',
    'storageBucket': 'mia-1on1navi-sas-referral.appspot.com',
    'authDomain': 'mia-1on1navi-sas-referral.firebaseapp.com',
    'messagingSenderId': '819399051114',
    'projectId': 'mia-1on1navi-sas-referral'
  },
  ddc: {
    'apiKey': 'AIzaSyC5UF3DbvFEKoievkuh-Qxs31w_0evHR9U',
    'databaseURL': 'https://mia-1on1navi-ddc.firebaseio.com',
    'storageBucket': 'mia-1on1navi-ddc.appspot.com',
    'authDomain': 'mia-1on1navi-ddc.firebaseapp.com',
    'messagingSenderId': '232463295011',
    'projectId': 'mia-1on1navi-ddc'
  },
  huber: {
    'apiKey': 'AIzaSyAihLXzxbV6zotxkcbOTeJEbSJzJXfjxhI',
    'databaseURL': 'https://mia-1on1navi-huber.firebaseio.com',
    'storageBucket': 'mia-1on1navi-huber.appspot.com',
    'authDomain': 'mia-1on1navi-huber.firebaseapp.com',
    'messagingSenderId': '19276374303',
    'projectId': 'mia-1on1navi-huber'
  },
  konicaminolta: {
    apiKey: 'AIzaSyAQvzOIjqkR2xGoOgi2NpCXFvAuAvG1l3o',
    authDomain: 'mia-1on1navi-konicaminolta.firebaseapp.com',
    databaseURL: 'https://mia-1on1navi-konicaminolta.firebaseio.com',
    projectId: 'mia-1on1navi-konicaminolta',
    storageBucket: 'mia-1on1navi-konicaminolta.appspot.com',
    messagingSenderId: '964183591212'
  },
  aimnext: {
    apiKey: 'AIzaSyAO1LCwDzLzUueyHladslgT2PUTrAJ7OZc',
    authDomain: 'mia-1on1navi-aimnext.firebaseapp.com',
    databaseURL: 'https://mia-1on1navi-aimnext.firebaseio.com',
    projectId: 'mia-1on1navi-aimnext',
    storageBucket: 'mia-1on1navi-aimnext.appspot.com',
    messagingSenderId: '435226239465'
  },
  talenta: {
    apiKey: 'AIzaSyASvM5L0wP8aMmhqoBFfcbUqhHR6hB-WNE',
    authDomain: 'mia-1on1navi-talenta.firebaseapp.com',
    databaseURL: 'https://mia-1on1navi-talenta.firebaseio.com',
    projectId: 'mia-1on1navi-talenta',
    storageBucket: 'mia-1on1navi-talenta.appspot.com',
    messagingSenderId: '891271722951'
  },
  trendmicroNg: {
    'apiKey': 'AIzaSyCEWhVNZhncW2hUNlg_DfG1hDx28WWlJ9U',
    'databaseURL': 'https://mia-1on1navi-trendmicro-ng.firebaseio.com',
    'storageBucket': 'mia-1on1navi-trendmicro-ng.appspot.com',
    'authDomain': 'mia-1on1navi-trendmicro-ng.firebaseapp.com',
    'messagingSenderId': '643234170304',
    'projectId': 'mia-1on1navi-trendmicro-ng'
  },
  trendmicro: {
    apiKey: 'AIzaSyC_bkqYd72QFFTFEKqiGppSt1NBGqFkNas',
    authDomain: 'mia-1on1navi-trendmicro.firebaseapp.com',
    databaseURL: 'https://mia-1on1navi-trendmicro.firebaseio.com',
    projectId: 'mia-1on1navi-trendmicro',
    storageBucket: 'mia-1on1navi-trendmicro.appspot.com',
    messagingSenderId: '875443854833'
  },
  partnerdemo1: {
    'projectId': 'mia-1on1navi-partnerdemo1',
    'databaseURL': 'https://mia-1on1navi-partnerdemo1.firebaseio.com',
    'storageBucket': 'mia-1on1navi-partnerdemo1.appspot.com',
    'locationId': 'us-central',
    'apiKey': 'AIzaSyAuJQw4NsM7C_W2yVOJnwwhr8gWB8kAJyY',
    'authDomain': 'mia-1on1navi-partnerdemo1.firebaseapp.com',
    'messagingSenderId': '435220178199'
  },
  demo3: {
    'apiKey': 'AIzaSyByuSvsvhOzPkGrfLrMqLVEr84wL9MadNs',
    'databaseURL': 'https://mia-1on1navi-demo3.firebaseio.com',
    'storageBucket': 'mia-1on1navi-demo3.appspot.com',
    'authDomain': 'mia-1on1navi-demo3.firebaseapp.com',
    'messagingSenderId': '277222950308',
    'projectId': 'mia-1on1navi-demo3'
  },
  demo2: {
    'projectId': 'mia-1on1navi-demo1-lite',
    'databaseURL': 'https://mia-1on1navi-demo1-lite.firebaseio.com',
    'storageBucket': 'mia-1on1navi-demo1-lite.appspot.com',
    'locationId': 'us-central',
    'apiKey': 'AIzaSyCk6lmozD6JnuSSn8ntRG7Tttx5kH57e0s',
    'authDomain': 'mia-1on1navi-demo1-lite.firebaseapp.com',
    'messagingSenderId': '727819004208'
  },
  demo1: {
    apiKey: 'AIzaSyD1FDvgUSgAS98FBpVITYGQItbeaRfW_Qo',
    authDomain: 'mia-1on1navi-beta.firebaseapp.com',
    databaseURL: 'https://mia-1on1navi-beta.firebaseio.com',
    projectId: 'mia-1on1navi-beta',
    storageBucket: 'mia-1on1navi-beta.appspot.com',
    messagingSenderId: '883479872321'
  },
  mia: {
    apiKey: 'AIzaSyBK6hJ4W_532NR_SKkeYV06Q1ElG_dLctE',
    authDomain: 'mia-1on1navi-com.firebaseapp.com',
    databaseURL: 'https://mia-1on1navi-com.firebaseio.com',
    projectId: 'mia-1on1navi-com',
    storageBucket: 'mia-1on1navi-com.appspot.com',
    messagingSenderId: '347856582744'
  },
  stag1: {
    'apiKey': 'AIzaSyB3DyofJqz03P8pCoOpmkXBF7PPtcJzGoU',
    'databaseURL': 'https://mia-1on1navi-stag1.firebaseio.com',
    'storageBucket': 'mia-1on1navi-stag1.appspot.com',
    'authDomain': 'mia-1on1navi-stag1.firebaseapp.com',
    'messagingSenderId': '1054644664721',
    'projectId': 'mia-1on1navi-stag1'
  },
  webBeta: {
    apiKey: 'AIzaSyAPE3wFE8FUn5viW8XjMujTQczP2Ivi1o8',
    authDomain: 'mia-1on1navi-deploygate.firebaseapp.com',
    databaseURL: 'https://mia-1on1navi-deploygate.firebaseio.com',
    projectId: 'mia-1on1navi-deploygate',
    storageBucket: 'mia-1on1navi-deploygate.appspot.com',
    messagingSenderId: '293592902153'
  },
  vitDev: {
    apiKey: 'AIzaSyBi1fuzY-REzISL38uy-_5jXCDoLe68gYo',
    authDomain: 'on1navi-1204.firebaseapp.com',
    databaseURL: 'https://on1navi-1204.firebaseio.com',
    projectId: 'on1navi-1204',
    storageBucket: 'on1navi-1204.appspot.com',
    messagingSenderId: '1086099765069'
  },
  vit1on1: {
    apiKey: 'AIzaSyDonljFZqGQu6KU2myf3WmOIW5J_VJqUgE',
    authDomain: 'vit-1on1.firebaseapp.com',
    databaseURL: 'https://vit-1on1.firebaseio.com',
    projectId: 'vit-1on1',
    storageBucket: 'vit-1on1.appspot.com',
    messagingSenderId: '473285992884'
  }
}

if (process.env) {
  if (process.env.FIREBASE_PROJECT) {
    console.log('process.env.FIREBASE_PROJECT:', process.env.FIREBASE_PROJECT)
    if (configs.hasOwnProperty(process.env.FIREBASE_PROJECT)) {
      console.log(configs[process.env.FIREBASE_PROJECT])
      project = process.env.FIREBASE_PROJECT
    }
  }
}

console.log('Firebase Project: ' + project)
const firebaseConfig = configs[project]

export default firebaseConfig



// WEBPACK FOOTER //
// ./src/firebase-setup/config/firebase-config.js